import { isIPad13, isMobile, isTablet } from "react-device-detect";

export const isPhone = () => {
  if (isMobile && !(isTablet || isIPad13)) {
    return true;
  }
  return false;
}
